import React from "react";
import useStyles from "./style";
import WarningIcon from "@material-ui/icons/Warning";
import { Typography } from "@material-ui/core";

function TopInfoBox({ text, subText, warningText, variant }) {
  const classes = useStyles();

  // Determine which class to use for the main container based on variant
  const topInfoClass =
    variant === "suspension"
      ? `${classes.topInfo} ${classes.suspensionInfo}`
      : classes.topInfo;

  return (
    <div style={{ width: "100%" }}>
      <div className={topInfoClass}>
        <h2 className={classes.infoText}>{text}</h2>
        {subText && (
          <div
            className={classes.infoSubText}
            style={{ whiteSpace: "pre-line" }}
          >
            {subText.split("<br/>").join("\n")}
          </div>
        )}
        {warningText && (
          <div className={classes.warningContainer}>
            <WarningIcon className={classes.warningIcon} />
            <Typography variant="body2" className={classes.warningText}>
              {warningText}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
}

export default TopInfoBox;
